import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import '../styles.less'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
// import ObjectiveView from '../../../widgets/projectProposal/objectiveGoal/ObjectiveView'
import GoalWidget from '../../../widgets/projectProposal/objectiveGoal/GoalWidget'
import ObjctiveWidget from '../../../widgets/projectProposal/objectiveGoal/ObjctiveWidget'
import ResultWidget from '../../../widgets/projectProposal/objectiveGoal/ResultWidget'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getObjectiveGoal, getIndicators, getObjective } from '../../../redux/actions/objectiveGoal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import pathname from '../../../constants/pathname'
import ActionPlanWidget from '../../../widgets/projectProposal/objectiveGoal/ActionPlanWidget'
import ConceptualWidget from '../../../widgets/projectProposal/objectiveGoal/ConceptualWidget'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import ViewPreviousVersionButon from '../../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Panel } from 'rsuite'

export default function ObjectiveGoal() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [indicatorForm, setIndicatorForm] = useState()
  const [showEditAll, setShowEditAll] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()

  // 🚩 1. เพิ่ม State สำหรับควบคุมการเปิด/ปิด โหมดเปรียบเทียบ
  const [isViewPrevious, setIsViewPrevious] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.budget}`,
    pathNameForward: `${pathname.proposal.backgroundAndImportant}`,
  }

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getObjectiveGoal(proposalId)
      // const _schema = mockSchema
      // console.log('ObjectiveGoal', JSON.stringify(_schema))
      setSchema(_schema)
      setIndicatorForm(_schema?.forms?.indicator)
      setIsEditWidget({
        goal: _schema.forms?.goal?.goal?.value?.length > 0 ? false : true,
        objective: _schema.forms?.objective?.objective?.value?.length > 0 ? false : true,
        indicator: _schema.forms?.indicator?.indicatorsResult?.value?.length > 0 ? false : true,
        actionPlan: _schema.forms?.actionPlan?.id ? false : true,
        conceptual: _schema.forms?.conceptual?.value?.length > 0 ? false : true,
      })
      setShowEditAll(
        !_schema.forms?.goal?.disabled &&
        !_schema.forms?.objective?.disabled &&
        !_schema.forms?.indicator?.disabled &&
        !_schema.forms?.actionPlan?.disabled &&
        !_schema.forms?.conceptual?.disabled
      )
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  // 🚩 2. ปรับฟังก์ชันดึงข้อมูลให้เป็นสวิตช์ Toggle และใช้ข้อมูลซ้ำได้หากเคยโหลดแล้ว
  const handleGetSchemaPrevious = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      
      const _schema = await getObjectiveGoal(proposalId)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetIndicator = async () => {
    try {
      const _schema = await getIndicators(projectId)
      // console.log('handleGetIndicator', _schema)
      setIndicatorForm(_schema)
    } catch (e) { }
  }

  const handleOnSuccess = async (res) => {
    console.log('res', res)
    if (res) {
      try {
        const _schema = await getObjective(projectId)
        console.log('_schema', _schema)
        setSchema((state) => ({
          ...state,
          forms: {
            ...state.forms,
            objective: _schema,
          },
        }))
      } catch (e) {
        console.log('error', e)
      }
    }
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  // 🚩 3. จับกลุ่ม UI ข้อมูลปัจจุบันมาไว้ในตัวแปรเดียว เพื่อให้โค้ดส่วน Return สะอาดขึ้น
  const renderCurrentVersion = (
    <div className="top">
      {/* เป้าประสงค์ */}
      {schema?.forms?.goal && (
        <>
          <GoalWidget
            showCommandButton={!schema.forms.goal.disabled}
            schema={schema.forms.goal}
            isEdit={isEditWidget.goal}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('goal', _isEdit, setIsEditWidget)}
          />
          <br />
        </>
      )}

      {/* วัตถุประสงค์ */}
      {schema?.forms?.objective && (
        <>
          <ObjctiveWidget
            showCommandButton={!schema.forms.objective.disabled}
            schema={schema.forms.objective}
            isEdit={isEditWidget.objective}
            handleGetIndicator={handleGetIndicator}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('objective', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}

      {/* ผลลัพธ์และตัวชี้วัด */}
      {indicatorForm && (
        <>
          <ResultWidget
            showCommandButton={!indicatorForm.disabled}
            schema={indicatorForm}
            isEdit={isEditWidget.indicator}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('indicator', _isEdit, setIsEditWidget)
            }
            onSuccess={(res) => handleOnSuccess(res)}
          />
          <br />
        </>
      )}

      {/* กรอบแนวคิด */}
      {schema?.forms?.conceptual && (
        <>
          <ConceptualWidget
            showCommandButton={!schema.forms.conceptual.disabled}
            schema={schema.forms.conceptual}
            isEdit={isEditWidget.conceptual}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('conceptual', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}

      {/* แผนดำเนินงาน/(ระเบียบวิธีการวิจัย) */}
      {schema?.forms?.actionPlan && (
        <>
          <ActionPlanWidget
            showCommandButton={!schema.forms.actionPlan.disabled}
            schema={schema?.forms?.actionPlan}
            isEdit={isEditWidget.actionPlan}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('actionPlan', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}
    </div>
  )

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />
        
        {/* 🚩 4. ส่งสถานะให้ปุ่มดูเวอร์ชันก่อนหน้า */}
        <ViewPreviousVersionButon 
          handleGetSchemaPrevious={handleGetSchemaPrevious} 
          isViewPrevious={isViewPrevious}
          masterSubjectId={'1-1014,1-1015,1-1016'}
        />

        {/* 🚩 5. ย้ายปุ่ม Edit All ออกมาอยู่ด้านบนสุดนอก Panel เพื่อไม่ให้ผูกติดกับโหมดการดู */}
        {showEditAll && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            routing={buttonRoute}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            editWidget={isEditWidget}
            forms={schema?.forms}
          />
        )}

        <div className="wrapper">
          {/* ==============================================
              ส่วนที่ 1: แสดงข้อมูลปัจจุบัน (ครอบด้วย Panel เมื่อเทียบเวอร์ชัน)
              ============================================== */}
          <div style={!isViewPrevious ? { width: '100%' } : {}}>
            {isViewPrevious ? (
              <Panel 
                //classPrefix="view-version-panel" 
                collapsible 
                defaultExpanded 
                shaded 
                bordered 
                header={'version ปัจจุบัน'}
                style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
              >
                {renderCurrentVersion}
              </Panel>
            ) : (
              renderCurrentVersion
            )}
          </div>

          {/* ==============================================
              ส่วนที่ 2: แสดงข้อมูลก่อนหน้า (ซ่อน/แสดง ตาม State)
              ============================================== */}
          {isViewPrevious && schemaPrevious && (
            <>
              <div className="line" />
              <div className="bottom">
                <Panel 
                  collapsible 
                  defaultExpanded 
                  shaded 
                  bordered                   
                  header={'version ก่อนหน้า'}
                  style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', backgroundColor: '#e4e4ed'  }}
                >
                  {/* เป้าประสงค์ */}
                  {schemaPrevious?.forms?.goal && (
                    <>
                      <GoalWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.goal}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {/* วัตถุประสงค์ */}
                  {schemaPrevious?.forms?.objective && (
                    <>
                      <ObjctiveWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.objective}
                        isEdit={false}
                        handleGetIndicator={() => {}} // ป้องกันการยิง API ซ้ำในเวอร์ชันเก่า
                      />
                      <br />
                    </>
                  )}

                  {/* ผลลัพธ์และตัวชี้วัด 🚩 เปลี่ยนเงื่อนไขเพื่อความปลอดภัยของโค้ด */}
                  {schemaPrevious?.forms?.indicator && (
                    <>
                      <ResultWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.indicator}
                        isEdit={false}
                        onSuccess={() => {}} // ป้องกันไม่ให้ trigger function ของเก่า
                      />
                      <br />
                    </>
                  )}

                  {/* กรอบแนวคิด */}
                  {schemaPrevious?.forms?.conceptual && (
                    <>
                      <ConceptualWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.conceptual}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}

                  {/* แผนดำเนินงาน/(ระเบียบวิธีการวิจัย) */}
                  {schemaPrevious?.forms?.actionPlan && (
                    <>
                      <ActionPlanWidget
                        showCommandButton={false}
                        schema={schemaPrevious.forms.actionPlan}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}
                </Panel>
              </div>
            </>
          )}
        </div>
      </SidebarProposal>
    </>
  )
}
// const mockSchema = {
//   header: 'วัตถุประสงค์',
//   subHeader: 'ข้อเสนอโครงการ การพัฒนาเทคโนโลยีสารสนเทศเพื่อการเกษตรครัวเรือน 04',
//   projecCode: 'R65-00164',
//   projecName: 'การพัฒนาเทคโนโลยีสารสนเทศเพื่อการเกษตรครัวเรือน 04',
//   disabled: false,
//   formTemplate: 0,
//   forms: {
//     goal: null,
//     objective: {
//       id: null,
//       disabled: false,
//       feedbackBySubject: null,
//       header: 'วัตถุประสงค์',
//       buttonText: 'วัตถุประสงค์',
//       objective: {
//         name: 'objective',
//         label: 'วัตถุประสงค์',
//         buttonText: 'วัตถุประสงค์',
//         message: [
//           {
//             type: 'warning',
//             description:
//               'วัตถุประสงค์ต้องสอดคล้องกับหลักการ เหตุผล และขอบเขตของโครงการ โดยหากเป็นโครงการภายใต้แผนงาน/ชุดโครงการ วัตถุประสงค์ควรเชื่อมโยงกับแผนงาน/ชุดโครงการ (ให้ระบุเป็นข้อ ๆ ไม่เกิน 255 ตัวอักษร)',
//           },
//         ],
//         value: [
//           {
//             index: 1,
//             value: 'เพื่อปลูกฝังให้เด็กและเยาวชนมีความคิดสร้างสรรค์',
//             isDisabled: false,
//             validators: null,
//             id: '6D10D556-3E49-4875-9A29-6BC564759F5E',
//           },
//         ],
//         validators: [
//           { type: 'REQUIRED', value: null, errorMessage: 'กรุณาเพิ่มอย่างน้อย 1 รายการ' },
//           {
//             type: 'MAXLENGTH',
//             value: 255,
//             errorMessage: 'กรอกวัตถุประสงค์ได้ไม่เกิน 255 ตัวอักษร',
//           },
//         ],
//       },
//     },
//     indicator: {
//       id: null,
//       disabled: false,
//       feedbackBySubject: null,
//       header: 'ผลลัพธ์, ตัวชี้วัด (outcome / Impact) : เชิงคุณภาพ',
//       buttonText: 'ผลลัพธ์และตัวชี้วัด',
//       indicatorsResult: {
//         name: 'indicatorsResult',
//         value: [
//           {
//             id: '6A5D4596-2C4F-48D5-8285-F73EE7A3EB8A',
//             index: 1,
//             objective: '6D10D556-3E49-4875-9A29-6BC564759F5E',
//             objectiveResult: 'ผลลัพธ์ของวัตถุประสงค์',
//             indicatorsList: [
//               {
//                 id: 'D1E247B3-D308-45D9-990B-7378346D8EA4',
//                 indicators: 'ตัวชี้วัดที่ 1',
//                 indicatorType: 0,
//                 count: null,
//                 unit: null,
//                 dataCollection: 'ข้อมูลที่จะเก็บ',
//                 dataCollectionMethod: 'วิธีเก็บข้อมูล',
//               },
//             ],
//           },
//         ],
//       },
//       objective: {
//         options: [
//           {
//             id: '6D10D556-3E49-4875-9A29-6BC564759F5E',
//             disabled: false,
//             label: 'เพื่อปลูกฝังให้เด็กและเยาวชนมีความคิดสร้างสรรค์',
//             value: '6D10D556-3E49-4875-9A29-6BC564759F5E',
//           },
//         ],
//         name: 'objective',
//         label: 'วัตถุประสงค์',
//         value: null,
//         hint: 'เลือกวัตถุประสงค์',
//       },
//       objectiveResult: { name: 'objectiveResult', label: 'ผลลัพธ์ของวัตถุประสงค์', value: '' },
//       indicatorsList: { name: 'indicatorsList', value: [] },
//       indicatorsText: 'ตัวชี้วัด',
//       indicators: {
//         name: 'indicators',
//         label: 'ตัวชี้วัดที่',
//         hint: 'ตัวชี้วัด',
//         value: '',
//         indicatorType: {
//           options: [
//             { disabled: false, label: 'เชิงคุณภาพ', value: 0 },
//             { disabled: false, label: 'เชิงปริมาณ', value: 1 },
//           ],
//           name: 'indicatorType',
//           label: null,
//           value: '',
//         },
//         count: { name: 'count', label: 'จำนวน', value: null },
//         unit: { name: 'unit', label: 'หน่วย', value: '' },
//         // dataCollection: {
//         //   name: 'dataCollection',
//         //   label: 'ข้อมูลที่จะเก็บ',
//         //   value: '',
//         //   validators: [],
//         // },
//         // dataCollectionMethod: {
//         //   name: 'dataCollectionMethod',
//         //   label: 'วิธีเก็บข้อมูล',
//         //   value: '',
//         //   validators: [],
//         // },
//       },
//     },
//     actionPlan: {
//       id: null,
//       disabled: false,
//       feedbackBySubject: null,
//       header: 'แผนดำเนินงาน/(ระเบียบวิธีการวิจัย)',
//       buttonText: 'แผนดำเนินงาน',
//       message: [
//         {
//           type: 'info',
//           description:
//             'กรณีที่เป็นโครงการชนิดโครงการพัฒนาและปฏิบัติการ หรือชนิดโครงการอุปถัมภ์กิจกรรม ให้ระบุขั้นตอนการทำงาน ส่วนโครงการชนิดวิจัยและประเมินผล ให้ระบุระเบียบวิธีวิจัย (Research Methodology)',
//         },
//       ],
//       editorData: {
//         name: 'editorData',
//         label: null,
//         value: '',
//         validators: [
//           { type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุ แผนดำเนินงาน' },
//           {
//             type: 'MAXLENGTH',
//             value: 4000,
//             errorMessage: 'ข้อความเกินกำหนด',
//           },
//         ],
//       },
//     },
//   },
// }
